module.exports = __webpack_public_path__ + "static/media/JonathanDonizdeJesus.cadaad11.png";